import { render, staticRenderFns } from "./create-somkeleaf.vue?vue&type=template&id=d5efed2c&"
import script from "./create-somkeleaf.vue?vue&type=script&lang=ts&"
export * from "./create-somkeleaf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports